import { getApplications } from "@/lib/applications/api";
import { ApplicationProjectGroup, GetManyResponse } from "@/types";
import { useSuspenseQuery } from "@tanstack/react-query";

const createEmptyResponse = <T>(): GetManyResponse<T> => ({
  limit: 0,
  offset: 0,
  hasNext: false,
  total: 0,
  items: [],
});

export function useGetApplications(
  limit: number,
  offset: number,
  searchTerm: string,
  category: string | null,
) {
  return useSuspenseQuery({
    queryKey: ["applications", limit, offset, searchTerm, category],
    queryFn: async () => {
      try {
        return await getApplications({
          limit,
          offset,
          search: searchTerm,
          category: category ?? undefined,
        });
      } catch (error) {
        console.error("Failed to fetch applications:", error);
        return { data: createEmptyResponse<ApplicationProjectGroup>() };
      }
    },
    select: (data) => {
      try {
        const payload = data?.data as
          | GetManyResponse<ApplicationProjectGroup>
          | undefined;
        return payload ?? createEmptyResponse<ApplicationProjectGroup>();
      } catch (error) {
        console.error("Error in applications select:", error);
        return createEmptyResponse<ApplicationProjectGroup>();
      }
    },
  });
}
